export default {
  setConsentStatus(state, payload) {
    state.consentStatus = payload
  },
  setPreferences(state, payload) {
    state.preferences = payload
  },
  setBannerVisible(state, payload) {
    state.bannerVisible = payload
  },
  setLastUpdated(state, timestamp) {
    state.lastUpdated = timestamp
  },
  resetPreferences(state) {
    state.consentStatus = null
    state.preferences = {
      necessary: true,
      analytics: false,
      advertising: false,
      functional: false
    }
    state.bannerVisible = true
    state.lastUpdated = null
  }
}
